import { dateFormatInverted } from 'constants/formats';
import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';
import { BeneficiaryWithEnvelopeId } from 'modules/beneficiaries/hooks/useGetBeneficiariesPendingEnvelopes';

export type BeneficiaryWithEnvelopeDownloadData = {
  _id: string;
  Nombre: string;
  Email: string;
  Plan: string;
  Estado: string;
  'Fecha de inicio': string;
  'Fecha de cancelación': string;
  'Unidades finales': number | string;
  'Envelope ID': string;
  'Envelope Signature ID': string;
  'Envelope Status': string;
};

export const parseResponseToDownloadData = (
  beneficiaries: BeneficiaryWithEnvelopeId[]
): BeneficiaryWithEnvelopeDownloadData[] => {
  if (!beneficiaries.length) return [];

  return beneficiaries.map((beneficiary) => ({
    _id: beneficiary._id || '-',
    Nombre: beneficiary.name,
    Email: beneficiary.email,
    Plan: beneficiary.planName,
    Estado: translate(beneficiary.invitationStatus || ''),
    'Fecha de inicio': format(
      new Date(beneficiary.planStartDate),
      dateFormatInverted
    ),
    'Fecha de cancelación': beneficiary?.cancelationDate
      ? format(new Date(beneficiary.cancelationDate), dateFormatInverted)
      : '-',
    'Unidades finales': beneficiary?.finalConsolidatedUnits || '-',
    'Envelope ID': beneficiary?.envelopeId || '-',
    'Envelope Signature ID': beneficiary?.envelopeSignatureId || '-',
    'Envelope Status': beneficiary?.envelopeStatus || '-',
  }));
};
